<template lang="html">
  <div class="prt-toast" :class="[color]" @click="handleBubbleClick">
    <span>{{content}}</span>
    <button :aria-label="action" v-if="callback && action" @click="fireCallback">{{action}}</button>
  </div>
</template>

<script>
export default {
  methods: {
    destroy() {
      this.$store.commit('removeToast', { toastId: this.id });
    },
    fireCallback() {
      this.callback();
      this.destroy();
    },
    handleBubbleClick() {
      if (this.callback || this.action) return;

      this.destroy();
    },
  },
  mounted() {
    if (this.timeout > 0) {
      window.setTimeout(() => {
        this.destroy();
      }, this.timeout);
    }
  },
  props: {
    action: String,
    callback: Function,
    color: {
      type: String,
      default: 'positive',
    },
    content: String,
    id: {
      type: String,
      required: true,
    },
    timeout: {
      type: Number,
      default: 2000,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-toast
    width: 100%
    padding: 20px
    color: white
    font-weight: bold
    overflow: hidden
    display: flex
    justify-content: space-between
    align-items: center
    box-sizing: border-box

    &.positive
      background-color: positive

    &.negative
      background-color: negative

    span
      height: auto
      display: inline-block

    button
      height: 40px
      font-family: inherit
      font-size: inherit
      text-transform: uppercase
      font-weight: bold
      letter-spacing: 1px
      border: none
      outline: none
      background-color: transparent
      color: inherit
      margin-left: 20px
      flex-shrink: 0
</style>
